import React, { useEffect, useRef, useState } from "react";
import Brand from "./dataCollection/Brand";
import SelectYear from "./dataCollection/SelectYear";
import Model from "./dataCollection/Model";
import Variant from "./dataCollection/Variant";
import RegdState from "./dataCollection/RegdState";
import FormData1 from "./dataCollection/FormData1";
import BuyersForm from "./dataCollection/BuyersForm";
import { toast } from "react-toastify";

const CarSelection = ({ transactionType, showCarSelection, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [selection, setSelection] = useState({
    brand: "",
    year: "",
    model: "",
    state: "",
  });
  const modalRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (showCarSelection) {
      document.addEventListener("mousedown", handleOutsideClick);
      document.addEventListener("keydown", handleEscKey);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.addEventListener("keydown", handleEscKey);
    };
  }, [showCarSelection, onClose]);

  const steps = [
    { component: <Brand onSelect={handleSelect} />, key: "Brands" },
    { component: <Model onSelect={handleSelect} />, key: "Model" },
    { component: <SelectYear onSelect={handleSelect} />, key: "Year" },
    { component: <Variant onSelect={handleSelect} />, key: "Variants" },
    { component: <RegdState onSelect={handleSelect} />, key: "Reg.state" },
    { component: <FormData1 onSubmit={handleSubmit} />, key: "Form" },
  ];

  function handleSelect(key, value) {
    if (!value) {
      alert("Please make a selection!");
      return;
    }
    setSelection((prev) => ({ ...prev, [key]: value }));
    setCurrentStep((prev) => prev + 1);
  }

  async function handleSubmit(formData) {
    const { variantSelection, ...otherData } = selection;

    // console.log(variantSelection, otherData);
    const formData1 = new FormData();

    formData1.append(
      "heading",
      `New Lead : ${formData?.name} Wants to know more ! Kindly check below details.`
    );
    formData?.name && formData1.append("name", formData?.name);
    formData?.email && formData1.append("email", formData?.email);
    formData?.mobileNumber &&
      formData1.append("mobileNumber", formData?.mobileNumber);
    (otherData?.brand || formData?.brand) &&
      formData1.append("brand", otherData?.brand || formData?.brand);
    otherData?.model && formData1.append("model", otherData?.model || "");
    otherData?.state && formData1.append("state", otherData?.state || "");
    otherData?.year && formData1.append("year", otherData?.year || "");
    formData?.price && formData1.append("price", formData?.price || "");
    variantSelection?.fuel &&
      formData1.append("fuel", variantSelection?.fuel || "");
    variantSelection?.transmission &&
      formData1.append("transmission", variantSelection?.transmission || "");
    formData?.message && formData1.append("message", formData?.message || "");
    transactionType &&
      formData1.append("subject", `Enquiry Form To ${transactionType}`);
    transactionType && formData1.append("toEmail", "vexoticcarsofficial@gmail.com");

    // for (let [key, value] of formData1.entries()) {
    //   console.log(key, value);
    // }

    fetch("https://api.smartaihr.com/api/users/sendingEmail", {
      method: "POST",
      body: formData1,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // console.log("Success:", data);
        toast.success("Your Data Sent Successfully!");
        onClose();
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Something went wrong. Please try again.");
      });
  }

  return (
    <div className="flex flex-col items-center justify-center fixed inset-0 bg-black bg-opacity-50 z-50">
      <div
        className={`relative bg-white overflow-auto w-full max-w-7xl p-8 transition-all duration-500 ease-in-out transform ${
          showCarSelection ? "opacity-100 scale-90" : "opacity-0 scale-90"
        }`}
        ref={modalRef}
      >
        {transactionType === "buy" ? (
          <BuyersForm onSubmit={handleSubmit} onClose={onClose} />
        ) : (
          <>
            <button
              onClick={onClose}
              className="absolute top-[-35px] right-2 mt-9 bg-red-500 text-white px-2 py-1 rounded"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L12 10.586l6.293-6.293a1 1 0 111.414 1.414L13.414 12l6.293 6.293a1 1 0 01-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 01-1.414-1.414L10.586 12 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <div className="grid grid-cols-3 gap-4 sm:flex sm:justify-center sm:items-center sm:gap-2.5 sm:space-x-4 mb-6">
              {steps.map((step, index) => (
                <button
                  key={index}
                  className={`p-3 text-lg font-bold leading-normal rounded-lg ${
                    currentStep === index
                      ? "bg-sky-600 text-white tracking-wide"
                      : "bg-white border border-black tracking-wide hover:bg-sky-400 hover:text-white transition-all duration-500"
                  } rounded`}
                  onClick={() => setCurrentStep(index)}
                  style={{
                    fontFamily: "Barlow Condensed",
                  }}
                >
                  {step.key}
                </button>
              ))}
            </div>

            {steps[currentStep].component}

            {currentStep > 0 && currentStep < steps.length && (
              <button
                className="px-4 py-2 mt-4 text-white bg-gray-800 rounded"
                onClick={() => setCurrentStep(currentStep - 1)}
              >
                Back
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CarSelection;
